import { GetStaticProps, InferGetStaticPropsType } from 'next'
import {
  PrivacyPolicies,
  PrivacyPolicies_privacyPolicies,
} from '@/apollo/__generated__/PrivacyPolicies'

import { PRIVACY_POLICY } from '@/apollo/queries/chacra.query'
import client from '@/apollo/apollo-client'

export { default } from '@/page-components/privacy-policy'

export const getStaticProps: GetStaticProps<{
  privacyPolicies: PrivacyPolicies_privacyPolicies[] | null
}> = async () => {
  const { data } = await client.query<PrivacyPolicies>({
    query: PRIVACY_POLICY,
  })

  return {
    props: {
      privacyPolicies: data.privacyPolicies,
    },
  }
}

export type PrivacyPolicyProps = InferGetStaticPropsType<typeof getStaticProps>
